/**
 * Função utilitária para formatar descrição de imóveis
 * Preserva as quebras de linha reais (\n) e remove a dependência de ponto e vírgula
 */

/**
 * Formata a descrição para exibição, preservando quebras de linha
 * Converte \n em quebras de linha HTML visíveis
 */
export const formatDescriptionForDisplay = (description: string | null | undefined): string => {
  if (!description) return '';
  
  // Remove tratamento antigo de ponto e vírgula (mantém para compatibilidade com dados antigos)
  let formatted = description
    .replace(/Administrador do Sistema/i, '')
    .replace(/\(11\) 99999-9999/i, '')
    .replace(/Sistema Administrator/i, '');
  
  // Preserva quebras de linha reais (\n)
  // Para compatibilidade com dados antigos que usam ; como quebra de linha,
  // primeiro converte ; em \n, depois formata todos os \n
  formatted = formatted.replace(/;\s*/g, '\n');
  
  // Normaliza quebras de linha (Windows, Mac, Unix)
  formatted = formatted.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  
  return formatted;
};

/**
 * Prepara a descrição para salvar no backend
 * Remove caracteres problemáticos mas preserva quebras de linha
 */
export const formatDescriptionForSave = (description: string): string => {
  if (!description) return '';
  
  // Remove caracteres de controle problemáticos, mas preserva \n
  let formatted = description
    .replace(/\r\n/g, '\n') // Normaliza Windows line breaks
    .replace(/\r/g, '\n')   // Normaliza Mac line breaks
    .trim();
  
  return formatted;
};

